import {Injectable} from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {ErpUserModel} from "../../models/resources/erp-user.model";
import {LanguageService} from "./language.service";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class ErpUserService extends AResourceService<ErpUserModel> {
  constructor(private languageService: LanguageService) {
    super('/erp-users', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{key: 'lang', value: code}];
  }
}
